import ContentRow from './ContentRow.vue'

export default ContentRow
